<div class="upsell-content p-lg">
  @if (limitType === 'asset') {
    <p>{{ 'upsellDialog.assetLimitReached' | translate: { plan: planName } }}</p>
  } @else {
    <p>{{ 'upsellDialog.formLimitReached' | translate: { plan: planName } }}</p>
  }
</div>
